/* Capelli — filtros de colección (v2.3)
 * 1) <cap-price-range>: barra de precio doble. Escribe en los campos de precio de Horizon;
 *    al soltar, el evento change llega a price-facet-component, que aplica el filtro.
 * 2) Botón flotante "Filtrar y ordenar" (mobile): visible después de pasar la barra
 *    superior y antes del footer (clase html.cap-fab-on).
 * 3) Columna lateral: calcula el tope y la altura para que el sticky nunca esconda filtros.
 */
(function () {
  'use strict';

  function digits(value) {
    var d = String(value == null ? '' : value).replace(/[^0-9]/g, '');
    return d ? parseInt(d, 10) : NaN;
  }

  if (!customElements.get('cap-price-range')) {
    customElements.define(
      'cap-price-range',
      class extends HTMLElement {
        get lo() {
          return this.querySelector('.cap-price__slider--min');
        }

        get hi() {
          return this.querySelector('.cap-price__slider--max');
        }

        field(name) {
          var facet = this.closest('price-facet-component');
          return facet ? facet.querySelector('input[name="' + name + '"]') : null;
        }

        connectedCallback() {
          if (!this._capBound) {
            this._capBound = true;
            this.addEventListener('input', this.onSlide.bind(this));
            var facet = this.closest('price-facet-component');
            if (facet) facet.addEventListener('change', this.onType.bind(this));
          }
          this.paint();
        }

        onSlide(event) {
          var lo = this.lo;
          var hi = this.hi;
          if (!lo || !hi) return;

          var top = Number(hi.max) || 0;
          var a = Number(lo.value);
          var b = Number(hi.value);
          if (a > b) {
            if (event.target === lo) {
              a = b;
              lo.value = String(a);
            } else {
              b = a;
              hi.value = String(b);
            }
          }

          var min = this.field('filter.v.price.gte');
          var max = this.field('filter.v.price.lte');
          if (min) min.value = a > 0 ? String(a) : '';
          if (max) max.value = b < top ? String(b) : '';
          this.paint();
        }

        onType(event) {
          var min = this.field('filter.v.price.gte');
          var max = this.field('filter.v.price.lte');
          if (event.target !== min && event.target !== max) return;

          var lo = this.lo;
          var hi = this.hi;
          if (!lo || !hi) return;

          var top = Number(hi.max) || 0;
          var a = digits(min && min.value);
          var b = digits(max && max.value);
          lo.value = String(isNaN(a) ? 0 : Math.min(a, top));
          hi.value = String(isNaN(b) ? top : Math.min(b, top));
          this.paint();
        }

        paint() {
          var lo = this.lo;
          var hi = this.hi;
          if (!lo || !hi) return;

          var top = Number(hi.max) || 1;
          this.style.setProperty('--cap-min', (Number(lo.value) / top) * 100 + '%');
          this.style.setProperty('--cap-max', (Number(hi.value) / top) * 100 + '%');
        }
      }
    );
  }

  var queued = false;
  var observed = null;
  var resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(queue) : null;

  function update() {
    queued = false;
    var root = document.documentElement;
    var bar = document.querySelector('[data-cap-facets-toolbar]');
    if (!bar) {
      root.classList.remove('cap-fab-on');
      return;
    }

    var sidebar = document.querySelector('.cap-facets-sidebar .facets--vertical');
    if (sidebar) {
      if (resizeObserver && observed !== sidebar) {
        if (observed) resizeObserver.unobserve(observed);
        resizeObserver.observe(sidebar);
        observed = sidebar;
      }

      var header = document.querySelector('.header-section');
      var headerBottom = 0;
      if (header) {
        var position = getComputedStyle(header).position;
        if (position === 'sticky' || position === 'fixed') {
          headerBottom = Math.max(0, header.getBoundingClientRect().bottom);
        }
      }

      var top = Math.round(headerBottom + 20) + 'px';
      var height = Math.round(sidebar.offsetHeight) + 'px';
      if (sidebar.style.getPropertyValue('--cap-sticky-top') !== top) {
        sidebar.style.setProperty('--cap-sticky-top', top);
      }
      if (sidebar.style.getPropertyValue('--cap-sb-h') !== height) {
        sidebar.style.setProperty('--cap-sb-h', height);
      }
    }

    var on = false;
    if (window.innerWidth < 750) {
      var passedBar = bar.getBoundingClientRect().bottom < 0;
      var footer = document.querySelector('footer');
      var beforeFooter = !footer || footer.getBoundingClientRect().top > window.innerHeight;
      on = passedBar && beforeFooter;
    }
    root.classList.toggle('cap-fab-on', on);
  }

  function queue() {
    if (queued) return;
    queued = true;
    setTimeout(update, 16);
  }

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  document.addEventListener('toggle', queue, true);
  document.addEventListener('DOMContentLoaded', queue);
  queue();
})();
